<div class="field">
  @if (label) {
    <div>
      <label
        class="bold"
        [id]="'lbl' + question_id"
        for="{{ question_id }}"
        [attr.aria-label]="label"
        style="display: inline"
        [attr.aria-hidden]="displayHelpText"
        >
        <span [hidden]="hide_label">{{ label }}</span>
        <div class="label-spacer-med"></div>
      </label>
      @if (displayHelpText) {
        <button
          tabindex="-1"
          aria-pressed="false"
          type="button"
          class="help"
          title="more info"
          placement="top-left"
          [attr.aria-label]="label"
          [ngbPopover]="popoverContent"
          >
          ?
        </button>
      }
      <ng-template #popoverContent>
        <div class="popoverTitle">More Info:</div>
        <div id="popoverContent" class="popoverContent" role="tooltip">
          {{ help_text }}
        </div>
      </ng-template>
    </div>
  }
  @if (isInvalid) {
    <div class="">
      <p [class.error]="isInvalid">{{ error_text }}</p>
    </div>
  }
  <div [formGroup]="paramFormGroup" class="input-spacer">
    @if (!required) {
      <span class="optional-text">(Optional)</span>
    }
    @if (readOnly) {
      <div>
        <label>{{ getCurrentChoice() }}</label>
      </div>
    } @else {
      @if (inputControl !== null) {
        <mat-form-field [id]="isInvalid ? 'invalid' : ''" type="dropdown" disableOptionCentering="true">
          <mat-select
            #input
            type="dropdown"
            [multiple]="isMultiple"
            [attr.id]="question_id"
            [id]="question_id"
            [formControl]="inputControl"
            class="focusInput"
            placeholder="{{ placeholder === null ? 'Select' : placeholder }}"
            hideSingleSelectionIndicator
            [attr.aria-label]="getAriaLabel()"
            attr.data-cy="{{ code }}"
            >
            @for (option of choices; track option) {
              <mat-option [value]="option.id">{{ choiceText(option) }}</mat-option>
            }
          </mat-select>
          <mat-placeholder></mat-placeholder>
        </mat-form-field>
      }
    }
  </div>
</div>
